import { render, staticRenderFns } from "./search_products.vue?vue&type=template&id=a25a86a8&"
import script from "./search_products.vue?vue&type=script&lang=js&"
export * from "./search_products.vue?vue&type=script&lang=js&"
import style0 from "./search_products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports